import React from 'react';
import addressIcon from 'components/assets/svg/link_icon.svg';
import styles from './TextLink.module.scss';
import cn from 'classnames';

const TextLink = ({
    text, withIcon, link, className, onClick,
}: IProps) => (
        <div className={cn(styles.link, className)} onClick={onClick}>
            {link ? (
                <a href={link} target="__blank">
                    <span className={styles.link_text}>{text}</span>
                    {withIcon ? (
                        <img className={styles.link_icon} src={addressIcon} alt="address_icon" />
                    ) : null}
                </a>
            ) : (
                    <>
                        <span className={styles.link_text}>{text}</span>
                        {withIcon ? (
                            <img className={styles.link_icon} src={addressIcon} alt="address_icon" />
                        ) : null}
                    </>
                )}
        </div>
    );

export default TextLink;

interface IProps {
    text: string;
    link?: string;
    withIcon?: boolean;
    className?: string;
    onClick?: () => void;
}
